import React, { useState, useEffect } from 'react';

const SubscriptionPage = ({ currentPlan, onUpgradePlan, isDarkMode, userId, onSelectPlanForPayment }) => {
  const [availablePlans, setAvailablePlans] = useState([]);
  const [loadingPlans, setLoadingPlans] = useState(true); 
  const API_BASE_URL = 'https://holmio.net/app/api.php'; 

  useEffect(() => {
    const fetchPlans = async () => {
      setLoadingPlans(true); 
      try {
        const response = await fetch(`${API_BASE_URL}/plans`);
        const data = await response.json();
        if (data.status === 'success') {
          setAvailablePlans(data.data);
        } else {
          console.error('Error al cargar planes:', data.message);
        }
      } catch (error) {
        console.error('Error de red o servidor al cargar planes:', error);
      } finally {
        setLoadingPlans(false); 
      }
    };
    fetchPlans();
  }, []);

  const handleChoosePlan = (plan) => {
    if (plan.price === "Gratis") { 
      onUpgradePlan(plan.id);
    } else {
      onSelectPlanForPayment(plan);
    }
  };

  const mainBgClass = isDarkMode ? 'bg-gray-800 text-white' : 'bg-gray-50 text-gray-800';
  const cardBgClass = isDarkMode ? 'bg-gray-900' : 'bg-white';
  const titleColorClass = isDarkMode ? 'text-white' : 'text-gray-800';
  const priceColorClass = isDarkMode ? 'text-blue-400' : 'text-blue-600';
  const textColorClass = isDarkMode ? 'text-gray-300' : 'text-gray-700';
  const currentPlanBorderClass = isDarkMode ? 'border-blue-500' : 'border-blue-500';
  const defaultBorderClass = isDarkMode ? 'border-gray-700' : 'border-gray-200';
  const currentPlanButtonClass = isDarkMode ? 'bg-green-700 text-white' : 'bg-green-500 text-white';
  const choosePlanButtonClass = isDarkMode ? 'bg-blue-600 text-white hover:bg-blue-500' : 'bg-blue-800 text-white hover:bg-blue-700';
  const customPlanBgClass = isDarkMode ? 'bg-gray-900' : 'bg-white';
  const customPlanTextColorClass = isDarkMode ? 'text-gray-300' : 'text-gray-700';
  const customPlanSubTextColorClass = isDarkMode ? 'text-gray-400' : 'text-gray-600';

  return (
    <main className={`flex-1 p-6 rounded-2xl shadow-xl m-4 ${mainBgClass} transition-colors duration-300`}>
      <h2 className="mb-8 text-4xl font-bold text-center">Elige tu Plan</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {loadingPlans ? (
          <div className="col-span-full text-center text-xl">Cargando planes...</div>
        ) : (
          availablePlans.map((plan) => (
            <div
              key={plan.id}
              className={`p-8 rounded-2xl shadow-lg flex flex-col items-center text-center transition-all duration-300 hover:scale-105
                ${cardBgClass}
                ${currentPlan === plan.id ? `border-4 ${currentPlanBorderClass}` : `border ${defaultBorderClass}`}`}
            >
              <h3 className={`text-3xl font-bold mb-4 ${titleColorClass}`}>
                {plan.name}
              </h3>
              <p className={`text-5xl font-extrabold mb-6 ${priceColorClass}`}>
                {plan.price === "Gratis" ? "Gratis" : `US$${plan.price}`}
              </p>
              <p className={`text-lg mb-4 ${textColorClass}`}>{plan.description}</p>
              <ul className="text-lg mb-8 space-y-2">
                <li className={`${textColorClass}`}>
                  {plan.device_limit === -1 ? 'Dispositivos ilimitados' : `${plan.device_limit} dispositivos`}
                </li>
                <li className={`${textColorClass}`}>
                  {plan.history_days === -1 ? 'Historial ilimitado' : `${plan.history_days} días de historial`}
                </li>
                <li className={`${textColorClass}`}>
                  Control remoto: {plan.remote_control ? 'Sí' : 'No'}
                </li>
              </ul>
              {currentPlan === plan.id ? (
                <button
                  className={`w-full py-3 rounded-xl text-lg font-semibold cursor-not-allowed opacity-70 
                    ${currentPlanButtonClass}`}
                  disabled
                >
                  Tu Plan
                </button>
              ) : (
                <button
                  onClick={() => handleChoosePlan(plan)}
                  className={`w-full py-3 rounded-xl text-lg font-semibold transition-colors shadow-md hover:shadow-lg transform hover:-translate-y-0.5
                    ${choosePlanButtonClass}`}
                >
                  Elegir Plan
                </button>
              )}
            </div>
          ))
        )}
      </div>
      <div className={`mt-12 p-6 text-center rounded-2xl shadow-lg ${customPlanBgClass}`}>
        <p className={`text-xl ${customPlanTextColorClass}`}>
          ¿Necesitas algo más personalizado?
        </p>
        <p className={`mt-2 ${customPlanSubTextColorClass}`}>
          Contáctanos para soluciones empresariales a medida.
        </p>
      </div>
    </main>
  );
};

export default SubscriptionPage;

// DONE